const allowedCharactersValues = ['alpha', 'numeric', 'alphanumeric'];
export default allowedCharactersValues;
